import Icon from '@ant-design/icons';
import { message } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import RightIcon from '@/components/Icon/svgs/right.svg';
import MindverseModal, { SizeType } from '@/components/modal';
import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';
import { useTranslation } from '@/i18n/client';
import { updateUserSettings } from '@/service/language';
import useUserSettings from '@/store/useUserSettings';
import AppLanguage from '@/ui/prefered-language';
import { EVENT } from '@/utils/event';

import styles from '../../index.less';
import { IconMap, MenuItem, MenuTNameMap } from '../constant';

interface IProps {}

const AppLanguageItem: React.FC<IProps> = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const languageList = useUserSettings((state) => state.languageList);
  const fetchUserLanguage = useUserSettings((state) => state.fetchUserLanguage);
  const userLanguage = useUserSettings((state) => state.userLanguage);
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');
  const [layoutSize] = useStorage('layoutSize');

  const { t } = useTranslation();

  // 获取用户设置
  useEffect(() => {
    setSelectedLanguage(userLanguage);
  }, [userLanguage]);

  // 点击确定更新用户设置
  const onOk = () => {
    updateUserSettings({ userLanguage: selectedLanguage })
      .then(() => {
        message.success('Update success');

        fetchUserLanguage();
      })
      .catch(() => {
        message.error('Update failed');

        setSelectedLanguage(userLanguage);
      });

    setShowModal(false);
  };

  return (
    <>
      {layoutSize === LAYOUT_SIZE.SMALL ? (
        <div
          className={styles.settingItem}
          onClick={() => {
            setShowModal(true);
            dispatchEvent(new Event(EVENT.FOLD_MENU));
          }}
        >
          <div className={styles.settingInfo}>
            <Icon component={IconMap[MenuItem.PreferredLanguage]} />
            <div>{t('menu.uiLanguage')}</div>
          </div>
          <div className="flex items-center">
            <div className="text-[#AD9B93]">
              {languageList.find((item) => {
                return item.languageCode === userLanguage;
              })?.nativeName ?? t('menu.uiLanguageSelect')}
            </div>
            <Icon className={styles.rightIcon} component={RightIcon} />
          </div>
        </div>
      ) : (
        <div
          className={classNames(styles.menuItem, 'pb-4', 'pt-4')}
          onClick={() => {
            setShowModal(true);
            dispatchEvent(new Event(EVENT.FOLD_MENU));
          }}
        >
          <div>
            <div>
              <Icon className={styles.icon} component={IconMap[MenuItem.AppLanguage]} />
              <span className={styles.text}>{t(MenuTNameMap[MenuItem.AppLanguage])}</span>
            </div>

            <div className={styles.language}>
              {languageList.find((item) => {
                return item.languageCode === userLanguage;
              })?.nativeName ?? t('menu.uiLanguageSelect')}
            </div>
          </div>
        </div>
      )}

      <MindverseModal
        cancelText={t('common.cancel')}
        destroyOnClose
        maskClosable={false}
        okText={t('common.save')}
        onCancel={() => setShowModal(false)}
        onOk={onOk}
        open={showModal}
        size={SizeType.normal}
        title={t(MenuTNameMap[MenuItem.AppLanguage])}
      >
        <AppLanguage
          languageCode={selectedLanguage || 'en'}
          languageList={languageList}
          setSelectedLanguage={setSelectedLanguage}
        />
      </MindverseModal>
    </>
  );
};

export default AppLanguageItem;
